export const API_ENDPOINTS = {
  search: "/search",
  auth: "/auth",
  team: "/team",
  channel: "/channel",
  user: "/user",
  log: "/logs",
  file: "/files",
};
